import './styles/app.css';
import { initAuth, renderLoginScreen } from './auth/auth.js';
import { getState, subscribe, setState } from './state/store.js';
import { loadSites } from './sites/sites.js';
import { loadRecentTransactions } from './transactions/transactions.js';
import { loadMaterialsForSite } from './materials/materials.js';
import { loadLabourForSite } from './labour/labour.js';
import { loadProjectHealth, loadDashboardTransactions } from './dashboard/projectHealth.js';
import { renderAppShell } from './ui/shell.js';
import { mountOverlays } from './ui/modals.js';
import { registerServiceWorker } from './pwa/registerServiceWorker.js';

const root = document.getElementById('app');
mountOverlays(document.body);

let sitesRequestedForSession = null; // session.user.id we've already kicked off loadSites() for
let siteDataRequestedForSite = null; // selectedSiteId we've already kicked off per-site loads for
let projectHealthRequestedForSession = null; // session.user.id we've already kicked off loadProjectHealth() for
let dashboardTxRequestedForSession = null; // session.user.id we've already kicked off loadDashboardTransactions() for

function render() {
  const state = getState();

  if (state.authStatus === 'loading') {
    root.innerHTML = '<div class="bootLoading">Loading…</div>';
    return;
  }

  if (state.authStatus === 'signed_out') {
    sitesRequestedForSession = null;
    siteDataRequestedForSite = null;
    projectHealthRequestedForSession = null;
    dashboardTxRequestedForSession = null;
    root.innerHTML = '';
    root.appendChild(renderLoginScreen());
    return;
  }

  // signed_in
  const userId = state.session?.user?.id;
  if (userId && sitesRequestedForSession !== userId) {
    sitesRequestedForSession = userId;
    loadSites();
  }
  if (userId && projectHealthRequestedForSession !== userId) {
    projectHealthRequestedForSession = userId;
    loadProjectHealth();
  }
  if (userId && dashboardTxRequestedForSession !== userId) {
    dashboardTxRequestedForSession = userId;
    loadDashboardTransactions();
  }
  if (state.selectedSiteId && siteDataRequestedForSite !== state.selectedSiteId) {
    siteDataRequestedForSite = state.selectedSiteId;
    loadRecentTransactions(state.selectedSiteId);
    loadMaterialsForSite(state.selectedSiteId);
    loadLabourForSite(state.selectedSiteId);
  }

  renderAppShell(root);
}

subscribe(render);
render();
initAuth();
registerServiceWorker();
